import api from './api';
import { MediaLibraryResponse, MediaLibraryQuery, MediaUploadResponse } from '../types/media.types';

class MediaService {
  private readonly baseUrl = '/v1/media';

  /**
   * Get media library images
   */
  async getMediaLibrary(params?: MediaLibraryQuery): Promise<MediaLibraryResponse> {
    const response = await api.get<MediaLibraryResponse>(`${this.baseUrl}/library`, { params });
    return response.data;
  }

  /**
   * Upload image to media library
   */
  async uploadImage(file: File): Promise<MediaUploadResponse> {
    const formData = new FormData();
    formData.append('image', file);

    const response = await api.post<MediaUploadResponse>(`${this.baseUrl}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  }

  /**
   * Get image URL by ID
   */
  getImageUrl(imageId: string): string {
    const baseURL = api.defaults.baseURL || '';
    return `${baseURL}${this.baseUrl}/images/${imageId}`;
  }
}

export const mediaService = new MediaService();
export default mediaService;
